var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgAlbumClientes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "78px",
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "serv_album") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets_Board",
    transform: "translate(-2469.000000, -442.000000)",
    fillRule: "nonzero",
    stroke: "",
    strokeWidth: 5.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "serv_album",
    transform: "translate(2472.166667, 445.166667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.8333333,0 L25.0833333,0 C7.16666667,0 0,7.16666667 0,25.0833333 L0,46.5833333 C0,64.5 7.16666667,71.6666667 25.0833333,71.6666667 L46.5833333,71.6666667 C64.5,71.6666667 71.6666667,64.5 71.6666667,46.5833333 L71.6666667,32.25",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6817606,1.54047881 C56.7242606,0.895478785 59.2684283,1.4329787 60.7017617,3.40381208 C62.0634284,1.3613121 64.6792637,0.859645486 66.7217637,1.54047881 C70.6275971,2.79464546 72.0250957,7.41714607 70.8425956,11.1438126 C68.9792624,17.0204792 62.5292625,20.1021451 60.7375959,20.1021451 C58.9100959,20.1021451 52.4959294,17.0921458 50.5967629,11.1438126 C49.4142628,7.41714607 50.8117605,2.79464546 54.6817606,1.54047881 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(20.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.214282,21.0444223 C9.63070417,20.8546192 5.196687,16.2281684 5.196687,10.5340741 C5.196687,4.721353 9.84184822,0 15.6131092,0 C21.3609097,0 26.0295336,4.721353 26.0295336,10.5340741 C26.0060731,16.2281684 21.5720532,20.8546192 15.9884754,21.0444223 C15.7538713,21.0206969 15.4723465,21.0206969 15.214282,21.0444223 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25806454,45.7258968 C10.7096773,50.091369 21.2903238,50.091369 27.7419366,45.7258968 C33.419356,41.8823833 33.419356,35.6188804 27.7419366,31.7990923 C21.3137842,27.4573455 10.7331377,27.4573455 4.25806454,31.7990923 C-1.41935485,35.6426058 -1.41935485,41.9061087 4.25806454,45.7258968 Z",
    id: "Vector"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgAlbumClientes);
export default __webpack_public_path__ + "static/media/svg_album_clientes.081736a79f7a609dbbef1fda7fac566c.svg";
export { ForwardRef as ReactComponent };